import styled from 'styled-components';

export const Container = styled.div``;

export const Overlay = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9998;
  opacity: ${({ $isOpen }) => ($isOpen ? '1' : '0')};
  pointer-events: ${({ $isOpen }) => ($isOpen ? 'auto' : 'none')};
  transition: opacity 0.3s ease;
`;

export const Drawer = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  width: 400px;
  height: 100vh;
  background-color: #f9f9f9;
  box-shadow: -5px 0 20px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  z-index: 9999;

  /* Slide from right */
  transform: translateX(${({ $isOpen }) => ($isOpen ? '0' : '100%')});
  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1);

  @media (max-width: 480px) {
    width: 100vw;
  }
`;

export const Header = styled.div`
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background-color: #fff;
`;

export const HeaderTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.h3`
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  color: #333;
`;

export const CloseButton = styled.button<{ $light?: boolean }>`
  background: #ec4d75;
  width: 38px;
  height: 38px;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: ${({ $light }) => ($light ? '#fff' : '#666')};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  cursor: pointer;

  &:hover {
    background-color: ${({ $light }) =>
    $light ? 'rgba(255,255,255,0.2)' : '#f5f5f5'};
  }
`;

export const TabContainer = styled.div`
  display: flex;
  background-color: #ffffff;
  padding: 4px;
  border-radius: 8px;
  gap: 4px;
`;

export const TabButton = styled.button<{ $active: boolean }>`
  flex: 1;
  padding: 6px 12px;
  border: none;
  background-color: ${({ $active }) => ($active ? '#E4003A' : 'transparent')};
  color: ${({ $active }) => ($active ? '#ffffff' : '#71717a')};
  font-size: 14px;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
`;

export const Content = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0;
  display: flex;
  flex-direction: column;
  /* background-color: #fcfcfc; */
`;

export const HomeHeader = styled.div`
  background-color: #e51d3b;
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: white;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  position: relative;
`;

export const HomeHeaderTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const ChatHeaderTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const UserGreeting = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const AgentAvatar = styled.div`
  width: 54px;
  height: 54px;
  border-radius: 50%;
  background-color: white;
  margin-bottom: 10px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.2);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const GreetingText = styled.h2`
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  line-height: 1.2;
  opacity: 0.8;
`;

export const SubGreetingText = styled.p`
  font-size: 24px;
  margin: 0;
  font-weight: 600;
  line-height: 1;
`;

export const TitleNewChat = styled.div`
  flex: 1;
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 10px;
`;

export const TitleText = styled.h2`
  font-size: 15px;
  line-height: 1.2;
  font-weight: 400;
  color: #fff;

  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
`;

export const HomeContent = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const HomeInputArea = styled.div`
  background-color: white;
  border-radius: 12px;
  display: flex;
  align-items: center;
  margin: 30px 20px 0px 20px;
  border: 1px solid #d9d9d9;
`;

export const SuggestionsTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  color: #333;
  margin-top: 10px;
`;

export const SuggestionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const SuggestionCard = styled.button`
  background-color: #f5f5f5;
  border: none;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  color: #666;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background-color: #eee;
    color: #333;
  }
`;

export const MessagesArea = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  overflow-y: auto;
  background-color: #fcfcfc;
`;

export const MessageBubble = styled.div<{ $role: 'user' | 'assistant' }>`
  max-width: 85%;
  padding: 12px 16px;
  border-radius: 12px;
  font-size: 14px;
  line-height: 150%;
  word-wrap: break-word;
  align-self: ${({ $role }) => ($role === 'user' ? 'flex-end' : 'flex-start')};

  background-color: ${({ $role }) =>
    $role === 'user' ? '#F3F3F3' : '#F7ECEE'};
  color: ${({ $role }) => ($role === 'user' ? '#393939' : '#393939')};

  // border: ${({ $role }) =>
    $role === 'assistant' ? '1px solid #e0e0e0' : 'none'};

  border-bottom-right-radius: ${({ $role }) =>
    $role === 'user' ? '4px' : '12px'};
  border-bottom-left-radius: ${({ $role }) =>
    $role === 'assistant' ? '4px' : '12px'};

  white-space: pre-wrap;
`;

export const MessageDate = styled.div`
  font-size: 12px;
  color: #999;
  margin-top: 4px;
`;

export const ChatInput = styled.div`
  background-color: #ffffff;
  border-top: 1px solid #eee;
`;

export const InputArea = styled.div`
  background-color: #f8f8f8 !important;
  border-radius: 12px;
  display: flex;
  align-items: center;
  margin: 20px;
`;

export const Input = styled.input`
  flex: 1;
  padding: 16px !important;
  border-radius: 24px;
  outline: none;
  font-size: 14px;
  font-weight: 600;
  color: #545454;
  transition: border-color 0.2s;

  ::placeholder {
    color: #545454;
    font-weight: 400;
    opacity: 0.6;
  }
`;

export const InputHome = styled.input`
  flex: 1;
  padding: 20px 16px !important;
  border: 1px solid #e0e0e0;
  border-radius: 24px;
  outline: none;
  font-size: 14px;
  font-weight: 600;
  color: #545454;
  transition: border-color 0.2s;
  background-color: #f9f9f9;

  ::placeholder {
    color: #545454;
    font-weight: 400;
    opacity: 0.6;
  }
`;

export const SendButton = styled.button`
  background: transparent;
  color: #545454;
  border: none;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: color 0.2s;
  margin-right: 16px;

  &:disabled {
    color: #ccc;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    color: #f7941d;
  }
`;

export const TypingIndicator = styled.div`
  display: flex;
  gap: 4px;
  padding: 12px 16px;
  background-color: #f7ecee;
  border-radius: 12px;
  border-bottom-left-radius: 4px;
  align-self: flex-start;
  width: fit-content;

  span {
    width: 6px;
    height: 6px;
    background-color: #393939;
    border-radius: 50%;
    animation: bounce 1.4s infinite ease-in-out both;

    &:nth-child(1) {
      animation-delay: -0.32s;
    }
    &:nth-child(2) {
      animation-delay: -0.16s;
    }
  }

  @keyframes bounce {
    0%,
    80%,
    100% {
      transform: scale(0);
    }
    40% {
      transform: scale(1);
    }
  }
`;

export const CenterLoading = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  width: 100%;
  gap: 4px;

  span {
    width: 6px;
    height: 6px;
    background-color: #ec4d75;
    border-radius: 50%;
    animation: bounce 1.4s infinite ease-in-out both;

    &:nth-child(1) {
      animation-delay: -0.32s;
    }
    &:nth-child(2) {
      animation-delay: -0.16s;
    }
  }

  @keyframes bounce {
    0%,
    80%,
    100% {
      transform: scale(0);
    }
    40% {
      transform: scale(1);
    }
  }
`;

export const HistoryList = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px;
  gap: 8px;
  background-color: #fcfcfc;
  flex: 1;
  overflow-y: auto;
`;

export const HistoryItem = styled.button<{ $active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px;
  border: 1px solid ${({ $active }) => ($active ? '#E4003A' : 'transparent')};
  background-color: ${({ $active }) => ($active ? '#F7ECEE' : '#F3F3F3')};
  border-radius: 8px;
  cursor: pointer;
  text-align: left;
  transition: all 0.2s;

  &:hover {
    background-color: #f9f9f9;
  }
`;

export const HistoryContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  overflow: hidden;
`;

export const HistoryTitle = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #393939;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const HistoryDate = styled.span`
  font-size: 10px;
  color: #393939;
`;

export const StatusBadge = styled.span<{ status: string }>`
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 10px;
  background-color: ${({ status }) =>
    status === 'open' || status === 'pending' ? '#dcfce7' : '#f3f4f6'};
  color: ${({ status }) => (status === 'open' || status === 'pending' ? '#166534' : '#6b7280')};
  font-weight: 600;
  text-transform: uppercase;
  margin-left: 8px;
`;

export const BottomTabBar = styled.div`
  display: flex;
  background-color: white;
  border-top: 1px solid #eee;
  padding: 8px 0;
  padding-top: 15px;
  padding-bottom: 20px;
`;

export const BottomTabItem = styled.button<{ $active: boolean }>`
  flex: 1;
  background: transparent;
  border: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  cursor: pointer;
  color: ${({ $active }) => ($active ? '#e51d3b' : '#999')};

  span {
    font-size: 20px;
  }

  label {
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
  }

  &:hover:not(:disabled) {
    color: ${({ $active }) => ($active ? '#e51d3b' : '#666')};
  }
`;
